import { render } from "./SalesForceUnsubscribe.vue?vue&type=template&id=665ecc0a"
import script from "./SalesForceUnsubscribe.vue?vue&type=script&lang=js"
export * from "./SalesForceUnsubscribe.vue?vue&type=script&lang=js"

import "./SalesForceUnsubscribe.vue?vue&type=style&index=0&id=665ecc0a&lang=css"

import exportComponent from "C:\\Projects\\Vind\\Vind\\VindFront\\VindFrontVueApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__